var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiUsageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 10.0002C3.3335 6.85746 3.3335 5.28612 4.3098 4.3098C5.28612 3.3335 6.85746 3.3335 10.0002 3.3335C13.1428 3.3335 14.7142 3.3335 15.6905 4.3098C16.6668 5.28612 16.6668 6.85746 16.6668 10.0002C16.6668 13.1428 16.6668 14.7142 15.6905 15.6905C14.7142 16.6668 13.1428 16.6668 10.0002 16.6668C6.85746 16.6668 5.28612 16.6668 4.3098 15.6905C3.3335 14.7142 3.3335 13.1428 3.3335 10.0002Z",
    stroke: "#626262",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 12.5L7.78491 7.89528C7.86359 7.65923 8.0845 7.5 8.33333 7.5C8.58217 7.5 8.80308 7.65923 8.88175 7.89528L10.4167 12.5M7.08333 10.8333H9.58333",
    stroke: "#626262",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9165 7.5V12.5",
    stroke: "#626262",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 1.6665V3.33317M13.3332 1.6665V3.33317M9.99984 1.6665V3.33317M6.6665 16.6665V18.3332M9.99984 16.6665V18.3332M13.3332 16.6665V18.3332M18.3332 13.3332H16.6665M3.33317 6.6665H1.6665M3.33317 13.3332H1.6665M3.33317 9.99984H1.6665M18.3332 6.6665H16.6665M18.3332 9.99984H16.6665",
    stroke: "#626262",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiUsageIcon);
export default __webpack_public_path__ + "static/media/ai-usage-icon.ab56ab292118354f86280fc1df8062d7.svg";
export { ForwardRef as ReactComponent };